import { CSSProperties } from 'react';
import { Transition } from '../Animations/Transitions/Transitions.types';
import { PositionStyleProperties } from '../Style/Position';
import { Volume } from '../Volume';
import { BaseElement } from './BaseElement';
import { Trim } from './Trim';
import { ElementType } from '../../../../../player-config/src/types/Element/Type';
import { Font } from '../Font';
import { SpeakerLabelTransitions } from '../../transitions';
import { SpeakerWithDetails } from '../../speaker-types';

export enum SpeakerLabelElementType {
  TEXT = 'TEXT',
  CONTAINER = 'CONTAINER'
}

export interface BaseSpeakerLabelInterface {
  style?: CSSProperties;
  type: SpeakerLabelElementType;
}

export interface SpeakerLabelTextInterface extends BaseSpeakerLabelInterface {
  type: SpeakerLabelElementType.TEXT;
  content: string;
}

export interface SpeakerLabel extends BaseSpeakerLabelInterface {
  type: SpeakerLabelElementType.CONTAINER;
  elements?: SpeakerLabelTextInterface[];
  font?: Font;
  titleFont?: Font;
  transitions?: SpeakerLabelTransitions;
}

export interface VideoElement extends BaseElement {
  type: ElementType.VIDEO;
  details: VideoElementDetails;
  trim: Trim;
  style: Partial<VideoStyleProperties>;
  containerStyle: Partial<VideoStyleProperties>;
  isOriginalVideo: boolean;
  speakerLabel?: SpeakerLabel;
  speakerDetails?: SpeakerWithDetails;
  aspectRatio?: number;
  transitions?: Transition;
}

interface VideoElementDetails {
  src: string;
  preview?: string;
  altText: string;
  volume: Volume;
  muted?: boolean;
  duration?: number;
}

export type VideoStyleProperties = PositionStyleProperties &
  Pick<
    CSSProperties,
    | 'opacity'
    | 'transform'
    | 'borderWidth'
    | 'borderColor'
    | 'borderStyle'
    | 'borderRadius'
    | 'backgroundColor'
    | 'rotate'
    | 'objectFit'
    | 'zIndex'
    | 'display'
  >;
